import React from 'react';
import { Calendar } from 'lucide-react';
import { format } from 'date-fns';

const PRESETS = [
  { k: 'all', label: 'All Time' },
  { k: 'today', label: 'Today' },
  { k: 'yesterday', label: 'Yesterday' },
  { k: 'last_week', label: 'Last Week' },
  { k: 'last_month', label: 'Last Month' },
  { k: 'custom', label: 'Custom Range' },
];

export const DateFilter = ({ datePreset, setDatePreset, customFrom, setCustomFrom, customTo, setCustomTo, dateRange }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 space-y-3" data-testid="expense-date-filter">
    <div className="flex items-center gap-2 text-sm font-semibold text-gray-700">
      <Calendar className="w-4 h-4 text-amber-600" />
      <span>Time Period</span>
      {dateRange.from && dateRange.to && (
        <span className="ml-auto text-xs font-normal text-gray-500">
          Showing: {format(dateRange.from, 'MMM dd, yyyy')} – {format(dateRange.to, 'MMM dd, yyyy')}
        </span>
      )}
    </div>
    <div className="flex flex-wrap gap-2">
      {PRESETS.map((opt) => (
        <button
          key={opt.k}
          onClick={() => setDatePreset(opt.k)}
          data-testid={`date-preset-${opt.k}`}
          className={`px-4 py-2 rounded-lg font-medium transition text-sm ${
            datePreset === opt.k
              ? 'bg-amber-500 text-white shadow'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
    {datePreset === 'custom' && (
      <div className="flex flex-wrap items-end gap-3 pt-2 border-t border-gray-100">
        <div>
          <label className="block text-xs text-gray-600 mb-1">From</label>
          <input
            type="date"
            value={customFrom}
            onChange={(e) => setCustomFrom(e.target.value)}
            data-testid="expense-custom-from"
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-600 mb-1">To</label>
          <input
            type="date"
            value={customTo}
            onChange={(e) => setCustomTo(e.target.value)}
            data-testid="expense-custom-to"
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
          />
        </div>
        {(!customFrom || !customTo) && (
          <p className="text-xs text-amber-600">Select both dates to apply custom range</p>
        )}
      </div>
    )}
  </div>
);

export const StatusFilter = ({ filterStatus, setFilterStatus }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
    <div className="flex flex-wrap gap-2">
      {['All', 'Pending', 'Approved', 'Rejected'].map(status => (
        <button
          key={status}
          onClick={() => setFilterStatus(status)}
          data-testid={`status-filter-${status.toLowerCase()}`}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            filterStatus === status
              ? 'bg-green-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {status}
        </button>
      ))}
    </div>
  </div>
);
